"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('discardSkypeOptions', function discardSkypeOptions() {
    var optionState = store_1.default();
    optionState.imNotification = null;
    optionState.callNotification = null;
});
//# sourceMappingURL=discardSkypeOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-skype-option/lib/data/mutators/discardSkypeOptions.js
// module id = 3373
// module chunks = 2 39